import React from 'react';
import PropTypes from 'prop-types';

import './SearchResultsListEmpty.scss';

const SearchResultsListEmpty = ({ searchQuery }) => (
    <div className="SearchResultsListEmpty">
        <div className="no-results">
            No results found for <span className="query">‘{searchQuery}’</span>
        </div>
        <div className="retry">Try adjusting your search</div>
    </div>
);

SearchResultsListEmpty.propTypes = {
    searchQuery: PropTypes.string,
};

export default SearchResultsListEmpty;
